import script from "./Timer.vue?vue&type=script&setup=true&lang=js"
export * from "./Timer.vue?vue&type=script&setup=true&lang=js"

export default script